import { Request } from 'express';

export const getUniqueIds = (req: Request): Record<string, string> => {
  const correlationId: string = req?.headers['x-correlation-id'] as string || '';
  const vcapRequestId: string = req?.headers['x-vcap-request-id'] as string || '';
  const currTimeStamp: string = Date.now().toString();
  const requestId: string = correlationId || vcapRequestId || currTimeStamp;

  return { requestId, correlationId, vcapRequestId, requestTimeStamp: currTimeStamp };
};
